import React from "react";

type KeyFeature = {
  icon: string;
  title: string;
  description: string;
};

type KeyFeaturesSectionProps = {
  title: string;
  subtitle?: string;
  features: KeyFeature[];
};

const KeyFeaturesSection: React.FC<KeyFeaturesSectionProps> = ({
  title,
  subtitle,
  features,
}) => {
  return (
    <section className="pt-80 pb-80">
      <div className="container">

        {/* SECTION HEADER */}
        <div className="text-center mb-60">
          <h2 className="xb-section-title wow fadeInUp">{title}</h2>
          {subtitle && (
            <p
              className="mt-15 wow fadeInUp"
              style={{
                maxWidth: "850px",
                margin: "0 auto",
                color: "rgba(255,255,255,0.8)",
                fontSize: "17px",
                lineHeight: "1.6",
              }}
            >
              {subtitle}
            </p>
          )}
        </div>

        {/* FEATURES GRID */}
        <div className="row mt-none-30">
          {features.map((item, i) => (
            <div
              key={i}
              className="col-lg-6 col-md-12 mt-30 wow fadeInUp"
              data-wow-delay={`${i * 100}ms`}
            >
              <div
                className="xb-keyfeature-card"
                style={{
                  height: "100%",
                  display: "flex",
                  gap: "22px",
                  padding: "34px 32px",
                  borderRadius: "18px",
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))",
                  border: "1px solid rgba(255,255,255,0.12)",
                  backdropFilter: "blur(12px)",
                  position: "relative",
                  overflow: "hidden",
                  transition: "0.35s ease",
                }}
              >
                {/* LEFT GRADIENT STRIP (UNIQUE TOUCH) */}
                <span
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "4px",
                    height: "100%",
                    background:
                      "linear-gradient(180deg, #e44616ff, #db520dff)",
                    opacity: 0.85,
                  }}
                />

                {/* ICON */}
                <div
                  style={{
                    minWidth: "64px",
                    height: "64px",
                    borderRadius: "16px",
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.18), rgba(255,255,255,0.05))",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid rgba(255,255,255,0.25)",
                    boxShadow: "0 0 0 rgba(0,0,0,0)",
                    transition: "0.35s ease",
                  }}
                  className="keyfeature-icon"
                >
                  <img src={item.icon} alt="icon" style={{ width: 36 }} />
                </div>

                {/* CONTENT */}
                <div>
                  <h4
                    style={{
                      color: "#fff",
                      fontWeight: 600,
                      marginBottom: "10px",
                    }}
                  >
                    {item.title}
                  </h4>
                  <p
                    style={{
                      color: "rgba(255,255,255,0.85)",
                      lineHeight: "1.6",
                      margin: 0,
                    }}
                  >
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* HOVER MAGIC (SCOPED, SAFE) */}
      <style>
        {`
          .xb-keyfeature-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 20px 50px rgba(0,0,0,0.35);
          }

          .xb-keyfeature-card:hover .keyfeature-icon {
            box-shadow: 0 0 30px rgba(106,92,255,0.45);
          }
        `}
      </style>
    </section>
  );
};

export default KeyFeaturesSection;
